import axios from '@/axios/api.request'

export const users = (from) => axios.request({
  url: 'order/commission/settle/users',
  data: from,
  method: 'post'
  })

export const back = (from) => axios.request({
  url: 'order/commission/settle/back',
  data: from,
  method: 'post'
})
export const save = (from) => axios.request({
  url: 'order/commission/settle/save',
  data: from,
  method: 'post'
})
export const edit = (from) => axios.request({
  url: 'order/commission/settle/edit',
  data: from,
  method: 'post'
})
export const backOne = (from) => axios.request({
  url: 'order/commission/settle/backOne',
  data: from,
  method: 'post'
})
export const finance = (from) => axios.request({
  url: 'order/commission/settle/finance',
  data: from,
  method: 'post'
})